export default class Navigation {
    constructor(menuHolder) {
        this.holder = document.querySelector(menuHolder)
        this.mobileSwitcher = this.holder.querySelector('.mobile-switcher')
        this.overlay = document.querySelector('.mobile-menu__overlay')
        this.close = document.querySelector('.js-close')

        this.init()
    }

    init() {
        this.setEventListeners()
    }

    setEventListeners() {
        this.mobileSwitcher.addEventListener('click', this.mobileMenuToggler.bind(this))
        this.overlay.addEventListener('click', this.mobileMenuToggler.bind(this))
        this.close.addEventListener('click', this.mobileMenuToggler.bind(this))
    }

    mobileMenuToggler() {
        document.body.classList.toggle('js-menu-is-open')
    }
}
